module.exports = __webpack_public_path__ + "assets/menu.b38ef06de09ee07f92eed460e0ee3fb8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/menu.svg
 ** module id = 163
 ** module chunks = 0
 **/